import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xiugaihuifu",
  "use": "icon-xiugaihuifu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xiugaihuifu\"><path d=\"M794.875096 455.111111L568.888889 239.32567 88.668199 719.54636 0 1024l304.45364-87.883525L794.875096 455.111111z m-39.233717-402.537931l-117.701149 117.70115L863.141762 386.05977l117.70115-117.701149c58.850575-58.850575 58.850575-156.934866 0-225.201533C921.992337-15.693487 823.908046-15.693487 755.641379 52.57318z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol